// import { OptIn } from 'lib/generated/graphql';
import { useMutation } from '@apollo/client';
import { CreateOptInMutation, CreateOptInMutationVariables, PostType } from 'lib/generated/graphql';
import { CREATE_OPT_IN_MUTATION } from 'lib/mutations';
import * as animationData from 'public/animations/tick.json';
import { useRef, useState } from 'react';
import Lottie from 'react-lottie';
import useNotification from 'src/hooks/useNotification';
import NewPost from 'src/shared-components/HuddleCard/Huddle/components/NewPost';
import FormOptIn from './FormOptIn';

const CreateOptIn = ({
  huddleId,
  projectName,
  projectGoals,
  onOptInCreated,
  onPostCreated,
  setIsLoading,
}: {
  huddleId: number;
  projectName: string;
  projectGoals: any;
  onOptInCreated: (optIn: any) => void;
  onPostCreated: () => void;
  setIsLoading?: (isLoading: boolean) => void;
}) => {
  const [optInId, setOptInId] = useState<number | null>();
  const childForms = useRef<any>([]);
  const [animationFinished, setAnimationFinished] = useState<boolean>();

  const [createOptInMutation] = useMutation<CreateOptInMutation, CreateOptInMutationVariables>(CREATE_OPT_IN_MUTATION);
  const { showError } = useNotification();
  const handleCreateOptIn = async (input: any) => {
    input.huddle = { connect: { id: huddleId } };

    try {
      if (setIsLoading) {
        setIsLoading(true);
      }
      const { data } = await createOptInMutation({
        variables: {
          input,
        },
      });
      global?.analytics?.track(`Opt'd In To Project`, {
        projectId: huddleId,
      });
      setOptInId(data?.createOptIn.id);
      if (setIsLoading) {
        setIsLoading(false);
      }
      onOptInCreated(data.createOptIn);
    } catch (error) {
      showError({
        title: error.message,
        description: 'You can only express interest in a project once',
      });
      if (setIsLoading) {
        setIsLoading(false);
      }
    }
  };

  // TODO: We are rendering NewPost here and in the parent that renders this component, there's probably a cleaner way to do this
  return (
    <>
      {optInId ? (
        <>
          {animationFinished ? (
            <NewPost
              type={PostType.Optin}
              huddleId={huddleId}
              optInId={optInId}
              projectName={projectName}
              onPostCreated={onPostCreated}
              canChangePrivacy
              setIsLoading={setIsLoading}
            />
          ) : (
            <Confirmation onAnimationComplete={() => setAnimationFinished(true)} />
          )}
        </>
      ) : (
        <FormOptIn
          projectGoals={projectGoals}
          ref={el => (childForms.current[0] = el)}
          onFormSubmitted={values => {
            handleCreateOptIn(values);
          }}
        />
      )}
    </>
  );
};

// TODO: Make this an external component
export const Confirmation = ({ onAnimationComplete }: { onAnimationComplete?: () => void }) => (
  <div className="text-center py-9">
    <Lottie
      options={{
        loop: false,
        autoplay: true,
        animationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      }}
      height={170}
      width={170}
      eventListeners={[
        {
          eventName: 'complete',
          callback: () => {
            if (onAnimationComplete) onAnimationComplete();
          },
        },
      ]}
    />
    <div className="text-2xl w-5/6 mx-auto font-bold mt-2">You&apos;ve successfully expressed interest!</div>
  </div>
);

export default CreateOptIn;
